import Vue from "vue";
import qs from "querystring";

let query = qs.parse(location.search.replace("?", "").replace(/\/.*/g, ""));
Vue.prototype.$query = query;
window.query = query;



// WEBPACK FOOTER //
// ./src/utils/addQuery.js